module.exports = __webpack_public_path__ + "static/etusivu-465x320-3521.f37c2878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/etusivu-465x320-3521.png
// module id = 811
// module chunks = 35783957827783